<section class="solutions-overview">

    <div class="container-redesign">

        <div class="solutions-overview__intro">

            <p>
                {{ introText }}
            </p>

        </div>

        <div class="solutions-overview__grid">

            <article
                class="solutions-card"
                *ngFor="let solution of solutions; trackBy: trackByTitle">

                <img
                    [src]="solution.icon"
                    [alt]="solution.title">

                <h3>
                    {{ solution.title }}
                </h3>

                <p>
                    {{ solution.description }}
                </p>

            </article>

        </div>

    </div>

</section>